import * as React from "react";
import {APP_URL, API_URL, SHOPIFY_REDIRECT_URL} from '../../../settings/local_settings';
import {AuthUrlLinkBase} from "./AuthUrlLinkBase";
import {ShopifyConnectButton} from "./ShopifyConnectButton";
import { withTranslation } from 'react-i18next';

export class ShopifyLinkComponentClass extends AuthUrlLinkBase {

    constructor(props) {
        super(props);
        this.state = {
            hasConnection: props.hasConnection,
            subdomain: props.subdomain,
            disabled: props.disabled
        };

        this.handleConnectClick = this.handleConnectClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.subdomain !== this.props.subdomain || prevProps.disabled !== this.props.disabled) {
            this.setState({ subdomain: this.props.subdomain, disabled: this.props.disabled });
        }
    }

    _getAuthURL(){
        const state = this._generateRandomState();
        sessionStorage.setItem('shopify_oauth_state', state);
        const baseUrl = SHOPIFY_REDIRECT_URL.replace('{{store_subdomain}}', this.state.subdomain).replace('{{redirect_uri}}', encodeURIComponent(APP_URL+"connect-shopify"));
        // Reemplazar el state estatico del template por uno random per-request (CSRF protection)
        return baseUrl.replace(/([?&])state=[^&]*/, '$1state=' + encodeURIComponent(state));
    }

    _generateRandomState(){
        if (window.crypto && window.crypto.randomUUID) {
            return window.crypto.randomUUID();
        }
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    }

    _getDeleteUrl(){
        return API_URL + 'agency/shopify-connection/delete/';
    }

    renderConnectionButton() {
        return <ShopifyConnectButton onClick={this.handleConnectClick} disabled={this.state.disabled} />;
    }

    renderDisconnectButton() {
        const { t } = this.props;
        return <button className="btn" onClick={this.deleteAgencyConnection}>{t('shopify_link.disconnect_from_shopify')}</button>
    }

    redirectToAuthPage() {
        window.location.href = this._getAuthURL();
    }

    handleConnectClick() {
        if (this.state.subdomain && !this.state.disabled) {
            this.redirectToAuthPage();
        }
    }
}

export const ShopifyLinkComponent = withTranslation()(ShopifyLinkComponentClass);
export default ShopifyLinkComponent;
